export interface LegacyCallDetailsViewColors {
  CallInfoTable: {
    Header: {
      FontColor: {
        default: string
      }
    }
    DataRow: {
      FontColor: {
        default: string
      }
    }
    Border: {
      default: string
    }
  }
}

export const legacyCallDetailsViewColors: LegacyCallDetailsViewColors = {
  CallInfoTable: {
    Header: {
      FontColor: {
        default: 'gray.800',
      },
    },
    DataRow: {
      FontColor: {
        default: 'gray.1300',
      },
    },
    Border: {
      default: 'gray.300',
    },
  },
}
